<template>
  <div class="info-section-1">

    <div class="info-container">

      <product-title
        main-title="Our solutions"
        :is-left=true
      />

      <tabs/>

    </div>
    <div class="laptop-asset-container">
      <img class="asset-mockup" src="../assets/mockup-images/mac-mockup.png" alt="">
      <div class="image-container image-tint">
        <img class="project-screenshot" src="../assets/mockup-images/crowdfunding.jpg" alt="">
      </div>
    </div>

  </div>
</template>

<script>
import ProductTitle from "../components/productComponents/ProductTitle";
import Tabs from "../components/tabs/Tabs";

export default {
  name: 'InfoSection1',
  components: {Tabs, ProductTitle},
}
</script>

<style lang="scss">
@import "InfoSection1.scss";
</style>
